<template>
  <el-dialog
    width="80%"
    ref="dialog"
    class="subTreeNodeView"
    :title="title"
    :visible.sync="dialogVisible"
  >
    <el-row :gutter="10">
      <!-- <el-col :span="4">
        <el-card class="box-card" shadow="never">
          <div style="color: #409EFF;margin-bottom: 10px">
            <i style="font-size: 20px;" class="iconfont icon-gongzuojilu2"></i>
            <h3 style="display:inline-block">展示大纲:</h3>
          </div>
          <div>
            <el-input class="filterInput" v-ripple placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
            <el-tree
              :data="subTaskList"
              ref="tree"
              node-key="id"
              :filter-node-method="filterNode"
              default-expand-all
              class="leftSubNodeView"
              @node-click="nodeClick"
            >
              <div slot-scope="{ node,data }">
                <span :title="data.NODENAME">{{data.LevelInstance}}、{{data.NODENAME}}</span>
              </div>
            </el-tree>
          </div>
        </el-card>
      </el-col>-->
      <el-col :span="24" class="rightSubNodeView">
        <el-card class="box-card" shadow="never">
          <div style="color: #409EFF;">
            <i style="font-size: 20px;" class="iconfont icon-renwutixing"></i>
            <h3 style="display:inline-block">完成情况:</h3>
          </div>
          <el-input class="filterInput" v-ripple placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
          <!-- <el-scrollbar :style="scorllStyle"> -->
          <el-tree :data="subTaskList" node-key="id" class="rightTree">
            <div :class="'custom-tree-node'+data.$id" slot-scope="{ node,data }">
              <span :style="getFontStyle(data)">
                <span
                  class="nodeTitle"
                  :title="data.NODENAME"
                  @click="openTaskDetail(data.RELATIONID)"
                >{{data.LevelInstance}}、{{data.NODENAME}}</span>
                <el-tag
                  :type="getStateType(data.RELATIONSTATE)"
                  effect="dark"
                  size="small"
                >{{data.RELATIONSTATE|stateFormat}}</el-tag>
              </span>
              <!-- <div class="nodeContent" v-html="getContent(data.Task)"> -->
              <!-- {{ data.Task.TASKNAME }} -->
              <!-- </div> -->
            </div>
          </el-tree>
          <!-- </el-scrollbar> -->
        </el-card>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      filterText: "",
      dialogVisible: false,
      subTaskList: [],
      scorllStyle: ``,
      title: ""
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  filters: {
    stateFormat(val) {
      var name = "";
      switch (val) {
        case 0:
        default:
          name = "待接收";
          break;
        case 1:
          name = "執行中";
          break;
        case 2:
          name = "已完成";
          break;
        case 3:
          name = "已結束";
          break;
      }
      return name;
    }
  },
  methods: {
    openTaskDetail(taskId) {
      let url = `${location.href.substr(
        0,
        location.href.lastIndexOf("/")
      )}/task-detailspage?taskid=${taskId}`;
      window.open(url);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.NODENAME.toUpperCase().indexOf(value.toUpperCase()) !== -1;
    },
    nodeClick(data, node) {
      var element = this.$el.querySelector(".custom-tree-node" + data.$id);
      element.scrollIntoView();
    },
    getStateType(state) {
      switch (state) {
        case 0:
          return "danger";
        case 1:
          return "";
        case 2:
          return "success";
        case 3:
          return "info";
        default:
          return "warning";
      }
    },
    getContent(node) {
      if (node) {
        return `<b>人员：</b>${this.getMembersName(node)} <br/>
                 <b>内容：</b> ${node.CONTENT} <br/>
                <span>${node.RecordInfo ? node.RecordInfo : ""}</span>`;
      }
    },
    getMembersName(node) {
      if (node.Members && node.Members.length > 0)
        return node.Members.map(o =>
          o.ISMONITOR ? `☆${o.USERNAME}` : o.USERNAME
        ).join("、");
      return "";
    },
    getFontStyle(node) {
      let fontsize = 20 - node.Level * 2;
      return (
        "font-weight: bold;color:#303133,margin-left:5px;font-size:" +
        `${fontsize > 14 ? fontsize : 14}px`
      );
    },
    OpenDialog(val) {
      this.dialogVisible = true;
      console.log("subTaskList", val);
      this.subTaskList = val.children;
      this.title = "【工作情况查看】" + val.NODENAME;
      this.$nextTick(() => {
        this.scorllStyle = `height:${this.$refs.dialog.$el.offsetHeight -
          100}px;width:${this.$refs.dialog.$el.offsetWidth - 100}px;`;
        console.log(this.scorllStyle);
      });
    }
  }
};
</script>

<style scoped>
.filterInput input[type="text"] {
  border: none !important;
  background: transparent !important;
  border-radius: 0 !important;
  border-bottom: 1px solid lightgray !important;
  outline: none !important;
}

.rightSubNodeView .el-tree-node__content {
  align-items: baseline !important;
  margin-top: 20px;
  cursor: text !important;
  height: 100% !important;
}

.leftSubNodeView .el-tree-node__content {
  align-items: baseline !important;
  margin-top: 10px;
  height: 100% !important;
}

.subTreeNodeView .el-dialog__body {
  padding: 10px 20px !important;
}

.subTreeNodeView .el-card__body {
  padding: 20px !important;
}
</style><style lang="scss" scoped>
.nodeContent {
  font-size: 14px;
  margin-left: 5px;
  line-height: 20px;
  margin-top: 5px;
  font-size: 14px;
  color: #606266;
}

.custom-tree-node {
  width: 100%;
  margin-top: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}

.nodeTitle {
  cursor: pointer;
}
</style>
